import { useState } from "react";
import CategoryTree from "./CategoryTree";
import FontList from "./FontList";
import { Font, FontCategory } from "@/interfaces/font.interface";

interface Props {
  onSelectFont?: (font: Font) => void;
}

export default function FontManagement({ onSelectFont }: Props) {
  const [category, setCategory] = useState<FontCategory>();

  return (
    <div className="flex h-full w-full flex-1 overflow-auto">
      <div className="h-full w-1/4 max-w-[300px] overflow-auto border-r-1 border-gray-300">
        <CategoryTree onChange={setCategory} />
      </div>
      <div className="h-full flex-1 overflow-auto">
        <FontList category={category} onSelect={onSelectFont} />
      </div>
    </div>
  );
}
